/**
 * 站点与服务地址：不同系统规律可能完全不同，固定逐个写死，禁止相互拼接。
 * 注：文本中的 MUSEX 为发布占位符，打包时会按产品类型替换（见 publish/type/*.json）。
 */

/** 应用基础地址 */
export const baseUrl = 'https://open.tecmz.com'
/** 开放接口基础地址 */
export const apiBaseUrl = 'https://open.tecmz.com/open_app/MUSEX'
/** 反馈入口（iframe 嵌入） */
export const feedbackUrl = 'https://open.tecmz.com/open_app/MUSEX/feedback_ticket'
